import { dependencies } from '@pn/core/dependencies';
import { ApiError } from '@pn/core/errors';
import { handleError } from '@pn/core/errors/handleError';
import { applyUserSettings } from '@pn/core/operations/userSettings';
import { currentUserActions } from '@pn/core/storage';
import { apiUserProvider } from '@pn/services/api/user/apiUserProvider';
import { useAuthenticationService } from '@pn/services/authentication';
import React from 'react';

async function getCurrentUser(logout: () => void) {
  try {
    currentUserActions().request();

    const { user, settings } = await apiUserProvider.getCurrentUser();

    currentUserActions().receive(user, settings);

    if (dependencies.appName === 'maps') applyUserSettings(settings);
  } catch (error) {
    if (
      error instanceof ApiError &&
      (error.code === 401 || error.code === 403)
    ) {
      logout();
    } else {
      handleError({
        error,
        onError: currentUserActions().error,
      });
    }
  }
}

export function useAutoGetCurrentUser() {
  const { isAuthenticated, logout } = useAuthenticationService();

  React.useEffect(() => {
    if (isAuthenticated) getCurrentUser(logout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);
}
